<template>
  <div>
    <div v-if="neighborhood">
      <business-profile-cdc-form
          v-if="cdcReportResult === null"
        issuer-key="0028590051"
        :social-name="person.name"
        :rfc="person.rfc"
        :street="person.address.street"
        :postal-code="neighborhood.zipcode"
        :neighborhood="neighborhood.name"
        :municipality="person.address.municipality"
        :city="neighborhood.city.name"
        :state="neighborhood.city.state.cc_code_pm"
        :country="neighborhood.city.state.country.cc_code"
        @onSubmit="submitHandler"
      />
      <business-profile-cdc-report-result
        v-if="cdcReportResult"
        :result="cdcReportResult" />
    </div>
    <vs-alert v-else>
      El negocio no tiene una colonia registrada favor de revisar.
    </vs-alert>

  </div>
</template>

<script>
import BusinessProfileCdcForm from "@views/admin/Score/BusinessProfile/BusinessProfileCdcForm";
import BusinessProfileCdcReportResult from "@views/admin/Score/BusinessProfile/BusinessProfileCdcReportResult";

export default {
  name: "BusinessProfileCdcModule",
  components: {BusinessProfileCdcReportResult, BusinessProfileCdcForm},
  props:["person"],
  data: () => ({
    neighborhood: null,
    cdcReportResult: null
  }),
  async mounted() {
    let result = await axios.get(`api/neighborhoods/${this.person.address.neighborhood_id}`);
    if(!result.error) {
      this.neighborhood = result.data;
    }

    await this.main()
  },
  methods: {
    async submitHandler(ev) {
      this.$vs.loading();
      try {
          let response = await axios.post(`/api/credit-score/moral`, {
              businessProfileId: this.person.id,
              ciudad: ev.city,
              colonia: ev.neighborhood,
              cp: ev.postalCode,
              direccion: ev.street,
              estado: ev.state,
              folioOtorgante: ev.issuerKey,
              municipio: ev.municipality,
              pais: ev.country,
              razonSocial: ev.socialName,
              rfc: ev.rfc
          })

          if (!response.error) {
              this.cdcReportResult = response.data.api_response;
          }
      } catch (e) {
          this.$vs.notify({
              title: 'Error',
              text: e.response.data.message,
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
          });
      } finally {
          this.$vs.loading.close();
      }
    },
    async main() {
      try {
        const {data} = await axios.get(`/api/credit-score/moral/${this.person.id}`);
        if (!data.error) {
          this.cdcReportResult = data.api_response;
        }
      } catch (e) {
        this.cdcReportResult = null;
      }
    }
  }
}
</script>

<style scoped>

</style>
